import { client } from "./index";
import { saveDownload } from "./orders";

// Products of one website (/api/admin/sites/:siteId/products)
export const getProducts = (siteId, params) => client.get(`/admin/sites/${siteId}/products`, { params });
export const createProduct = (siteId, payload) => client.post(`/admin/sites/${siteId}/products`, payload);
export const updateProduct = (siteId, productId, payload) => client.put(`/admin/sites/${siteId}/products/${productId}`, payload);
export const deleteProduct = (siteId, productId) => client.delete(`/admin/sites/${siteId}/products/${productId}`);
// Clothing stores: the garment colours in a product photo, { colors: [{ name, hex, share }] }
export const detectColors = (siteId, url) => client.post(`/admin/sites/${siteId}/products/detect-colors`, { url }).then((res) => res.data.colors);

// Combo packs: { name, price, items: [{ id, qty }], desc?, img?, offerTitle?, offerNote? }
export const createCombo = (siteId, payload) => client.post(`/admin/sites/${siteId}/products/combos`, payload);
export const updateCombo = (siteId, productId, payload) => client.put(`/admin/sites/${siteId}/products/combos/${productId}`, payload);

// Products and categories as a spreadsheet: format "xlsx" or "csv"
export async function exportCatalog(siteId, format) {
  const response = await client.get(`/admin/sites/${siteId}/products/export`, { params: { format }, responseType: "blob" });
  saveDownload(response.data, `${siteId}-products.${format}`, format === "csv" ? "text/csv;charset=utf-8;" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
}
export const importCatalog = (siteId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return client.post(`/admin/sites/${siteId}/products/import`, formData);
};

// The editor needs the whole catalogue, so walk through every page (the API caps a page at 100)
export async function getAllProducts(siteId) {
  const products = [];
  let page = 1;
  let pages = 1;
  while (page <= pages) {
    const { data } = await getProducts(siteId, { page, limit: 100, sort: "featured" });
    products.push(...data.products);
    pages = data.pages;
    page += 1;
  }
  return products;
}
